/**
 * Composition method for endpoint header
 * 
 * Author: Sahil David <sahil.david@huumun.com>
 */

import { computed, inject, onMounted, ref, watch } from 'vue';
import { useRoute } from 'vue-router';

import { getLyraEndpoints, getLyraEndpoint, getLyraCitation} from '@/core/modules/lyra/services';
import { toKebabCaseId } from '@/core/services/core.utils';

import citationsConfig from '@/core/modules/citations/config/citations.config';

export function endpointHeaderComposition () {
	const route = useRoute();
	const sections = getLyraEndpoints('sections');

	// Computed properties
	const sectionId = computed((): string => route.params.sectionId as string);
	const endpointId = computed((): string => route.params.endpointId as string);
	
	const endpointObj = computed((): any => {
		const currentSection: any = sections.find((_: any) => _.endpointId === sectionId.value);
        return getLyraEndpoint(endpointId.value, currentSection.endpoints);
    })
	
	// Computed breadcrumbs
	const breadcrumbsLevels = computed((): string[] => {
		const levels: string[] = [];
		const category: string = toKebabCaseId(sections.find((_: any) => _.endpointId === sectionId.value).sections);
        const subsection: string = toKebabCaseId(endpointObj.value['sub-sections']);
        const endpoint: string = toKebabCaseId(endpointId.value);

		if (category) levels.push(category);
		if (subsection) levels.push(subsection);
		if (endpoint) levels.push(endpoint);

        return levels;
    });
	
	// Function to action PDF links
	function openPDF (url: string) {
		window.open(url);
	}

	// Citations
	const citationsType = ref<string[]>([]);
	const citationsTypes = citationsConfig.map((_: any) => _.type);
	const endpointDataHeader = inject<any>('endpointData');

	// Function to derive citations data
	function deriveData () {
		citationsType.value = [];

		(endpointDataHeader.value.citations || []).forEach((citation: string) => {
			const obj = getLyraCitation(citation);
			if (!obj) { return; }

			const { type } = obj;
			if (!citationsType.value.includes(type)) { citationsType.value.push(type); }
		});
	}

	watch(() => endpointDataHeader.value, () => {
		deriveData();
	})

	// Lifecycle
	onMounted(() => {
		deriveData();
	})

	return { 
		sectionId, breadcrumbsLevels, openPDF,
		citationsTypes, citationsType
	}
}
